export function libCloneObject<T>(value: T): T {
	if (typeof value === 'object') {
		const json = JSON.stringify(value);

		return JSON.parse(json);
	}

	return value;
}
